module.exports = __webpack_public_path__ + "static/img/7_western_eastern_japan.d5ff50e6.png";